import './Statistic.css';
import {
  RadialChart,
  DiscreteColorLegend,
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  VerticalBarSeries,
} from 'react-vis';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { getAllFlashcardHeaders } from '../../actions/flashcards';
import { getTrainings } from '../../actions/trainings';
import { getTests } from '../../actions/tests';
import { useEffect, useState } from 'react';
import {
  // createData,
  testIntervals,
  testIntervalsInSecs,
} from '../Flashcards/Flashcardselection';
import { calcAchivement } from '../Trainings/Testform';
import AuthService from '../..//api/auth.service';

let seriesColor = [];

const visualizationTypes = [
  'intervals',
  'possible progress',
  'tests',
  'progress',
]; // number of tests: passed, failed, all

function hslToHex(h, s, l) {
  h /= 360;
  s /= 255;
  l /= 255;
  let r, g, b;
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  const toHex = (x) => {
    const hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

const timestamp = new Date('May 23 2017').getTime();
const ONE_DAY = 86400000;
const ONE_HOUR = 3600000;
const todayHOUR = Date.parse(new Date().toISOString()) / ONE_HOUR;
const today = Date.parse(new Date().toISOString()) / ONE_DAY;
const grid = [Math.floor(today) * ONE_DAY];

function Statistic() {
  const flashcardHeaders = useSelector((state) => state.flashcardHeaders);
  const trainings = useSelector((state) => state.trainings);
  const tests = useSelector((state) => state.tests);

  const [filterTrainings, setFilterTrainings] = useState('');
  const [filterIntervals, setFilterIntervals] = useState('');
  const [successfulDistribution, setSuccessfulDistribution] = useState(false);
  const [isHoveringOver, setIsHoveringOver] = useState(false);
  const [hoveredPoint, setHoveredPoint] = useState({
    x: 0,
    y: 0,
    passlevel: 0,
    number: 0,
  });

  const [state, setState] = useState({
    dataTimeDay: [[]],
    dataTimeHour: [[]],
    flashcardHeaders: flashcardHeaders,
    testableFlashcardHeaders: [],
    data: [],
    minx: 0,
    maxx: 0,
    arrayX: [],
    arrayXHour: [],
  });

  const [visualizationType, setVisualizationType] = useState(
    visualizationTypes[0],
  );

  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
    }
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllFlashcardHeaders());
    dispatch(getTrainings());
    dispatch(getTests());
  }, [dispatch]);

  useEffect(() => {
    if (flashcardHeaders.length > 0 && trainings.length > 0) {
      let filteredFlashcardHeaders = flashcardHeaders.filter(
        (card) => card.header.active,
      );

      if (filterTrainings != '') {
        filteredFlashcardHeaders = filteredFlashcardHeaders.filter(
          (flashcard) =>
            filterTrainings.some((training) =>
              flashcard.header.trainings.includes(training),
            ),
        );
      } else if (trainings.length > 0) {
        filteredFlashcardHeaders = filteredFlashcardHeaders.filter(
          (flashcard) =>
            trainings.some(
              (training) =>
                flashcard.header.trainings.includes(training.name) &&
                training.active,
            ),
        );
      }

      if (filterIntervals != '') {
        filteredFlashcardHeaders = filteredFlashcardHeaders.filter(
          (flashcard) =>
            filterIntervals.some((interval, i) => {
              return (
                flashcard.header.passlevel ===
                testIntervals.findIndex(
                  (testInterval) => testInterval == interval,
                )
              );
            }),
        );
      }

      for (let i = 0; i < testIntervals.length; i++) {
        if (seriesColor.length <= i) {
          seriesColor.push(hslToHex(((i * 360) / 20) % 360, 255, 128));
        }
      }

      let data = testIntervals.map((interval, i) => {
        return {
          title: interval,
          count: filteredFlashcardHeaders
            .map((card) => card.header.passlevel)
            .filter((x) => x === i).length,
          color: seriesColor[i],
        };
      });

      let testableFlashcardHeaders = filteredFlashcardHeaders
        .map(
          (card) =>
            card.header.trainings.length > 0 &&
            Date.parse(card.header.lastpass) +
              testIntervalsInSecs[card.header.passlevel] * 1000 <
              Date.parse(new Date().toISOString()),
        )
        .filter((x) => x === true).length;

      let dataTimeDay = [[]];
      dataTimeDay.length = testIntervalsInSecs.length;
      for (let i = 0; i < dataTimeDay.length; i++) {
        dataTimeDay[i] = [];
      }
      let dataTimeDaytmp = [];

      for (let i = 0; i < filteredFlashcardHeaders.length; i++) {
        if (filteredFlashcardHeaders[i].lastpass !== '') {
          let date;
          let filteredFlashcardHeader = JSON.parse(
            JSON.stringify(filteredFlashcardHeaders[i].header),
          );
          while (
            filteredFlashcardHeader.passlevel < testIntervalsInSecs.length
          ) {
            date =
              (Date.parse(filteredFlashcardHeader.lastpass) +
                testIntervalsInSecs[filteredFlashcardHeader.passlevel] * 1000) /
              ONE_DAY;
            if (date - Date.parse(new Date().toISOString()) / ONE_DAY > 365) {
              break;
            }
            switch (visualizationType) {
              case 'possible progress':
                dataTimeDaytmp.push({
                  x: Math.floor(date) * ONE_DAY,
                  y: calcAchivement(
                    filteredFlashcardHeader.passlevel + 1,
                    filteredFlashcardHeader.passlevel,
                  ),
                  color: seriesColor[0],
                  passlevel: 0,
                });
                break;
              case 'intervals':
              default:
                dataTimeDaytmp.push({
                  x: Math.floor(date) * ONE_DAY,
                  y: 1,
                  color: seriesColor[filteredFlashcardHeader.passlevel],
                  passlevel: filteredFlashcardHeader.passlevel,
                });
                break;
            }
            if (!successfulDistribution) {
              break;
            }
            filteredFlashcardHeader.lastpass = new Date(
              date * ONE_DAY,
            ).toISOString();
            filteredFlashcardHeader.passlevel += 1;
          }
        }
      }

      let maxx = -1000000 * ONE_DAY;
      let minx = 1000000 * ONE_DAY;
      for (let i = 0; i < dataTimeDaytmp.length; i++) {
        minx = Math.min(dataTimeDaytmp[i].x, minx);
        maxx = Math.max(dataTimeDaytmp[i].x, maxx);
      }
      maxx = Math.max(
        maxx,
        Math.floor(Date.parse(new Date().toISOString()) + 365 * ONE_DAY),
      );
      minx = Math.min(minx, Math.floor(today) * ONE_DAY - ONE_DAY);

      for (let i = 0; i < testIntervalsInSecs.length; i++) {
        for (let j = 0; j < (maxx - minx) / ONE_DAY; j++) {
          dataTimeDaytmp.push({
            x: minx + ONE_DAY * j,
            y: 0,
            color: seriesColor[i],
            passlevel: i,
          });
        }
      }

      for (let i = 0; i < dataTimeDaytmp.length; i++) {
        for (let j = i + 1; j < dataTimeDaytmp.length; j++) {
          if (
            dataTimeDaytmp[i].x === dataTimeDaytmp[j].x &&
            dataTimeDaytmp[i].passlevel === dataTimeDaytmp[j].passlevel
          ) {
            dataTimeDaytmp[i].y = dataTimeDaytmp[i].y + dataTimeDaytmp[j].y;
            dataTimeDaytmp.splice(j, 1);
            j--;
          }
        }
      }

      for (let i = 0; i < dataTimeDaytmp.length; i++) {
        dataTimeDay[dataTimeDaytmp[i].passlevel].push(dataTimeDaytmp[i]);
      }

      for (let i = 0; i < dataTimeDay.length; i++) {
        dataTimeDay[i].sort((a, b) => a.x - b.x);
      }

      let dataTimeHour = [[]];
      dataTimeHour.length = testIntervalsInSecs.length;
      for (let i = 0; i < dataTimeHour.length; i++) {
        dataTimeHour[i] = [];
      }
      let dataTimeHourtmp = [];

      for (let i = 0; i < filteredFlashcardHeaders.length; i++) {
        if (filteredFlashcardHeaders[i].header.lastpass !== '') {
          let date =
            (Date.parse(filteredFlashcardHeaders[i].header.lastpass) +
              testIntervalsInSecs[
                filteredFlashcardHeaders[i].header.passlevel
              ] *
                1000) /
            ONE_HOUR;
          if (date < todayHOUR + 25) {
            date = Math.max(date, todayHOUR);
            switch (visualizationType) {
              case 'possible progress':
                dataTimeHourtmp.push({
                  x: Math.floor(date) * ONE_HOUR,
                  y: calcAchivement(
                    filteredFlashcardHeaders[i].header.passlevel + 1,
                    filteredFlashcardHeaders[i].header.passlevel,
                  ),
                  color: seriesColor[0],
                  passlevel: 0,
                });
                break;
              case 'intervals':
              default:
                dataTimeHourtmp.push({
                  x: Math.floor(date) * ONE_HOUR,
                  y: 1,
                  color:
                    seriesColor[filteredFlashcardHeaders[i].header.passlevel],
                  passlevel: filteredFlashcardHeaders[i].header.passlevel,
                });
                break;
            }
          }
        }
      }

      let maxxHour = -1000000 * ONE_HOUR;
      let minxHour = 1000000 * ONE_HOUR;
      for (let i = 0; i < dataTimeHourtmp.length; i++) {
        minxHour = Math.min(dataTimeHourtmp[i].x, minxHour);
        maxxHour = Math.max(dataTimeHourtmp[i].x, maxxHour);
      }

      for (let i = 0; i < testIntervalsInSecs.length; i++) {
        for (let j = 0; j < 24; j++) {
          dataTimeHourtmp.push({
            x: minxHour + ONE_HOUR * j,
            y: 0,
            color: seriesColor[i],
            passlevel: i,
          });
        }
      }

      for (let i = 0; i < dataTimeHourtmp.length; i++) {
        for (let j = i + 1; j < dataTimeHourtmp.length; j++) {
          if (
            dataTimeHourtmp[i].x === dataTimeHourtmp[j].x &&
            dataTimeHourtmp[i].passlevel === dataTimeHourtmp[j].passlevel
          ) {
            dataTimeHourtmp[i].y = dataTimeHourtmp[i].y + dataTimeHourtmp[j].y;
            dataTimeHourtmp.splice(j, 1);
            j--;
          }
        }
      }

      for (let i = 0; i < dataTimeHourtmp.length; i++) {
        dataTimeHour[dataTimeHourtmp[i].passlevel].push(dataTimeHourtmp[i]);
      }

      for (let i = 0; i < dataTimeHour.length; i++) {
        dataTimeHour[i].sort((a, b) => a.x - b.x);
      }

      let arrayX = [];
      for (
        let i = 0;
        i <=
        Math.min(
          (maxx - minx) / ONE_DAY,
          Math.floor(today) - minx / ONE_DAY + 31,
        );
        i++
      ) {
        arrayX.push(minx + (i + 0.5) * ONE_DAY);
      }

      let arrayXHour = [];
      for (let i = 0; i < 25; i++) {
        arrayXHour.push((todayHOUR + i) * ONE_HOUR);
      }

      setState({
        dataTimeDay: dataTimeDay,
        dataTimeHour: dataTimeHour,
        filteredFlashcardHeaders: filteredFlashcardHeaders,
        testableFlashcardHeaders: testableFlashcardHeaders,
        data: data,
        minx: minx,
        maxx: maxx,
        arrayX: arrayX,
        arrayXHour: arrayXHour,
      });
    }
  }, [
    flashcardHeaders,
    trainings,
    filterIntervals,
    filterTrainings,
    successfulDistribution,
    visualizationType,
  ]);

  let startFalseHoverTimer;

  const onValueMouseOver = (datapoint, event) => {
    clearTimeout(startFalseHoverTimer);
    setIsHoveringOver(true);
    setHoveredPoint({
      x: event.event.pageX,
      y: event.event.pageY - 40,
      passlevel: datapoint.passlevel,
      number:
        datapoint.y0 !== undefined ? datapoint.y - datapoint.y0 : datapoint.y,
    });
  };

  const onValueMouseOut = () => {
    startFalseHoverTimer = setTimeout(() => setIsHoveringOver(false), 300);
  };

  const testsToday =
    tests !== undefined && currentUser !== undefined
      ? tests.filter((test) => {
          return (
            test.tester === currentUser.username &&
            Math.floor(Date.parse(test.conductiondate)) >
              Math.floor(today) * ONE_DAY &&
            Math.floor(Date.parse(test.conductiondate)) <
              Math.floor(today + 1) * ONE_DAY
          );
        })
      : [];

  const achievements = testsToday.map((test) =>
    calcAchivement(test.newpasslevel, test.oldpasslevel),
  );

  const todayProgressSum =
    achievements.length > 0 ? achievements.reduce((a, b) => a + b, 0) : 0;
  const todayAnsweredCount = testsToday.length;

  return (
    <div
      style={{
        margin: 0,
        display: 'inline-block',
        textAlign: 'left',
      }}
    >
      <h1>statistic</h1>
      {/* display currentUser */}
      <p>
        today's progress from{' '}
        {currentUser !== undefined ? currentUser.username : 'user'}:
      </p>
        {todayProgressSum} (level sum){' / '}
        {todayAnsweredCount} (answered flashcard
        {todayAnsweredCount === 1 ? '' : 's'})

      <p>filter trainings:</p>
      <Autocomplete
        multiple
        id="tags-standard"
        options={trainings.map((training) => training.name)}
        onChange={(event, values) => {
          event.preventDefault();
          setFilterTrainings(values.map((value) => value));
        }}
        style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label=""
            placeholder="select training name"
          />
        )}
      />
      <p>filter intervals:</p>
      <Autocomplete
        multiple
        id="tags-standard"
        options={testIntervals.map((interval) => interval)}
        onChange={(event, values) => {
          event.preventDefault();
          setFilterIntervals(values.map((value) => value));
        }}
        style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label=""
            placeholder="select intervals"
          />
        )}
      />
      {state.filteredFlashcardHeaders !== undefined &&
      state.filteredFlashcardHeaders.length > 0 ? (
        <>
          <p>
            number of flashcards:{' '}
            {state.filteredFlashcardHeaders
              ? state.filteredFlashcardHeaders.length
              : null}
          </p>
          <p>flashcards ready for test: {state.testableFlashcardHeaders}</p>
          <h1>distribution over memory intervals:</h1>
          <RadialChart
            innerRadius={0}
            radius={115}
            getAngle={(d) => d.count}
            data={state.data}
            height={250}
            width={250}
            getLabel={(d) =>
              `${d.count} (${
                Math.round(
                  (d.count / state.filteredFlashcardHeaders.length) * 1000,
                ) / 10
              }%)`
            }
            showLabels
            colorType="literal"
          ></RadialChart>
          <DiscreteColorLegend
            items={state.data.map((d, i) => {
              return {
                title: ` ${d.title}: ${d.count} (${
                  Math.round(
                    (d.count / state.filteredFlashcardHeaders.length) * 1000,
                  ) / 10
                }%)`,
                color: seriesColor[i],
                strokeWidth: 5,
              };
            })}
          />
          <div style={{ marginTop: '20px' }}>
            <h1>distribution over time</h1>
            <p>visualization:</p>
            <Select
              defaultValue={visualizationTypes[0]}
              onChange={(e) => {
                setVisualizationType(e.target.value);
              }}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {visualizationTypes.map((interval) => (
                <MenuItem key={interval} value={interval}>
                  {interval}
                </MenuItem>
              ))}
            </Select>
            <Checkbox
              onClick={(event) =>
                setSuccessfulDistribution(event.target.checked)
              }
              checked={successfulDistribution}
            />
            show distribution if all answers are successful
            <h3>1 year:</h3>
            <XYPlot
              xDomain={[state.minx, state.maxx]}
              xType="time"
              width={900}
              height={300}
              stackBy="y"
              margin={{ left: 70 }}
            >
              <HorizontalGridLines />
              <XAxis
                style={{
                  fontSize: '0.9em',
                }}
              />
              <YAxis />
              {state.dataTimeDay.map((entry, index) => (
                <VerticalBarSeries
                  key={`verticalBarYear${index}`}
                  data={entry}
                  style={{ stroke: '#fff' }}
                  colorType="literal"
                  onValueMouseOver={onValueMouseOver}
                  onValueMouseOut={onValueMouseOut}
                />
              ))}
              <VerticalGridLines
                tickTotal={grid.length}
                tickValues={grid}
                style={{
                  strokeWidth: '1px',
                  stroke: 'gray',
                  strokeDasharray: '5',
                }}
              />
            </XYPlot>
            <h3>1 month:</h3>
            <XYPlot
              xDomain={[state.minx, (Math.floor(today) + 31) * ONE_DAY]}
              xType="time"
              width={900}
              height={300}
              margin={{ bottom: 100, left: 70 }}
              stackBy="y"
            >
              <HorizontalGridLines />
              <XAxis
                tickLabelAngle={-90}
                tickValues={state.arrayX}
                tickFormat={function tickFormat(d) {
                  const date = new Date(d);
                  return date.toISOString().substr(0, 10);
                }}
                left={30}
                style={{
                  fontSize: '0.9em',
                }}
              />
              <YAxis />
              {state.dataTimeDay.map((entry, index) => (
                <VerticalBarSeries
                  key={`verticalBarYear${index}`}
                  data={entry}
                  style={{ stroke: '#fff' }}
                  colorType="literal"
                  onValueMouseOver={onValueMouseOver}
                  onValueMouseOut={onValueMouseOut}
                />
              ))}
              <VerticalGridLines
                tickTotal={grid.length}
                tickValues={grid}
                style={{
                  strokeWidth: '1px',
                  stroke: 'gray',
                  strokeDasharray: '5',
                }}
              />
            </XYPlot>
            <h3>1 day:</h3>
            <XYPlot
              xDomain={[todayHOUR * ONE_HOUR, (todayHOUR + 24) * ONE_HOUR]}
              xType="time"
              width={900}
              height={300}
              margin={{ bottom: 100, left: 70 }}
              stackBy="y"
            >
              <VerticalGridLines />
              <HorizontalGridLines />
              <XAxis
                // tickLabelAngle={-90}
                tickValues={state.arrayXHour}
                tickFormat={function tickFormat(d) {
                  // const date = new Date(d)
                  // return date.toISOString().substr(0, 16)
                  if (d / ONE_HOUR - todayHOUR === 0) {
                    return `-∞`;
                  } else {
                    return `+${d / ONE_HOUR - todayHOUR}h`;
                  }
                }}
                // left={20}
                style={{
                  fontSize: '0.9em',
                }}
              />
              <YAxis />
              {state.dataTimeHour.map((entry, index) => (
                <VerticalBarSeries
                  key={`verticalBarYear${index}`}
                  data={entry}
                  style={{ stroke: '#fff' }}
                  colorType="literal"
                  onValueMouseOver={onValueMouseOver}
                  onValueMouseOut={onValueMouseOut}
                />
              ))}
            </XYPlot>
            {isHoveringOver ? (
              <div
                style={{
                  color: 'black',
                  borderRadius: '10px',
                  left: `${hoveredPoint.x}px`,
                  top: `${hoveredPoint.y}px`,
                  position: 'absolute',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  backgroundColor: 'rgba(100, 100, 100, 0.5)',
                  variant: 'contained',
                  size: 'large',
                }}
              >
                {(visualizationType === 'intervals'
                  ? testIntervals[hoveredPoint.passlevel] + ': '
                  : '') + hoveredPoint.number}
              </div>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
}

export default Statistic;
